import script from "./stock.vue?vue&type=script&setup=true&lang=js"
export * from "./stock.vue?vue&type=script&setup=true&lang=js"

import "./stock.vue?vue&type=style&index=0&id=16824be2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16824be2"]])

export default __exports__